import { render } from "./Nodemailer.vue?vue&type=template&id=81e8b720"
import script from "./Nodemailer.vue?vue&type=script&lang=js"
export * from "./Nodemailer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__